import { QuizSessionProvider, useEventContext } from 'contexts';
import { Link, Route, Routes, useParams } from 'react-router-dom';
import { ErrorLocal, PrivateRoute, Spinner } from 'components';
import { useQuery } from '@apollo/client';
import { getQuizSession } from 'graphql/queries';
import { QuizSession, QuizSessionVariables } from 'graphql/queries/types/QuizSession';
import { QuizSessionQuiz } from './quiz-session-quiz';
import { NavPages, NavUtils } from 'utils';
import { QuizSessionOverview } from './overview/quiz-session-overview';
import { QuizSessionSetup } from './quiz-session-setup';
import { PresentQuizForQuickAnswer } from './quick-answer/present-quiz-for-quick-answer';

export const QuizSessionRouter = () => {
    const event = useEventContext();
    const params = useParams();
    const quizId = parseInt(params.quizId!);
    const sessionKey = params.sessionKey!;

    const {
        loading,
        error,
        data: quizSessions
        // refetch
    } = useQuery<QuizSession, QuizSessionVariables>(getQuizSession, {
        variables: { sessionKey }
    });

    if (loading) return <Spinner />;
    if (error) return <ErrorLocal errorMessage="Error getting quiz session :(" errorDetails={error} />;

    const sessions = quizSessions?.quiz_master_quiz_session ?? [];
    if (sessions.length !== 1) {
        if (sessions.length > 1) {
            console.error('Multiple sessions found with the same key!');
        }

        return (
            <div className="aq-content">
                <h3>Session link is invalid or unavailable</h3>
                <p>
                    We could not find an active session for this link. You can return to the quiz start page or go to the quiz list.
                </p>
                <p>
                    <Link to={NavUtils.generateNavPath(NavPages.Quiz, quizId, event?.alias)}>
                        Go to quiz start page
                    </Link>
                </p>
                <p>
                    <Link to={NavUtils.getQuizSelectorPath(event?.alias)}>
                        Go to quiz list
                    </Link>
                </p>
            </div>
        );
    }

    return (
        <QuizSessionProvider quizSession={sessions[0]!}>
            <Routes>
                <Route path="/" element={<PrivateRoute />}>
                    <Route path="/" element={<QuizSessionQuiz />} />
                </Route>
                <Route path="/overview" element={<PrivateRoute />}>
                    <Route path="/overview" element={<QuizSessionOverview />} />
                </Route>
                <Route path="/edit" element={<PrivateRoute />}>
                    <Route path="/edit" element={< QuizSessionSetup />} />
                </Route>
                <Route path="/present" element={<PrivateRoute />}>
                    <Route path="/present" element={< PresentQuizForQuickAnswer />} />
                </Route>
            </Routes>
        </QuizSessionProvider>
    );
};
